export const ERROR_CHANNEL_CHECK = {
    BOT_IS_NOT_ADMIN: 'BOT_IS_NOT_ADMIN',
    NO_ACCESS: 'NO_ACCESS',
};

export const API_STATUS = {
    ERROR: 'error',
    OK: 'ok',
};
